module.exports = __webpack_public_path__ + "img/upper pocket entry length.9b0619dd.png";